import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { useGetCurrentVendor } from "../../hooks/global/User";

function ReportDatePresets({ startDate, endDate, displayFormat, handlePresets }) {
  const { t } = useTranslation();

  const today = moment();

  const vendor = useGetCurrentVendor();

  const presets = [
    { 
      text: t("common.dr0"),
      trText: t("common.dr0"),
      start: moment().subtract(30, "days"),
      end: today,
    },
    {
      text: t("common.dr1"),
      trText: t("common.dr1"),
      start: moment().subtract(1, "weeks").startOf("week"),
      end: moment().subtract(1, "weeks").endOf("week"),
    },
    {
      text:  t("common.dr2"),
      trText: t("common.dr2"),
      start: moment().subtract(1, "months").startOf("month"),
      end: moment().subtract(1, "months").endOf("month"),
    },
    {
      text: t("common.dr3"),
      trText: t("common.dr3"),
      start: moment(vendor.created),
      end: moment().endOf("day"),
    },
  ];
  return (
    <div>
      {" "}
      <div className="btn-wrap text-center" style={{ textAlign: "center" }}>
        {presets.map(({ text, start, end }) => {
          const isSelected =
            moment(start).format(displayFormat) ===
              moment(startDate).format(displayFormat) &&
            moment(end).format(displayFormat) ===
              moment(endDate).format(displayFormat);
          return (
            <Button
              key={text}
              type="button"
              className={"btn btn-datePicker"}
              style={{ marginRight: 10 }}
              onClick={() => handlePresets({ start, end })}
            >
              {text}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

export default ReportDatePresets;
